"use client"

import { Heading1 } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `Heading1Icon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const Heading1Icon = component(Icon)({ as: Heading1 })
